import { Reveal, SectionHeading } from "./Reveal";
import { DIFFERENTIALS } from "../../data/site";

export const Differentials = () => (
  <section id="vantagens" className="py-20 lg:py-28" data-testid="differentials-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        number="03"
        eyebrow="Vantagens"
        title="Porquê escolher a TopEstofos?"
        subtitle="Cuidado profissional, pensado para o seu conforto e para a saúde da sua casa."
      />

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {DIFFERENTIALS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.08}>
            <div
              data-testid={`differential-card-${i}`}
              className="group h-full rounded-3xl border border-slate-100 bg-white p-7 shadow-[0_4px_24px_rgba(11,25,44,0.05)] transition-all duration-500 hover:-translate-y-1.5 hover:border-brand/20 hover:shadow-[0_20px_50px_rgba(0,102,255,0.12)]"
            >
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-gradient-to-br from-brand-50 to-aqua-100 transition-transform duration-500 group-hover:scale-110">
                <item.icon className="h-6 w-6 text-brand" />
              </span>
              <h3 className="mt-5 text-lg font-bold tracking-tight text-navy">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-500">{item.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
